import {ReactNode} from "react";
import {css} from "@panda/css";

interface IProps {
    children: ReactNode;
    "data-testid"?: string;
}

export const DetailSectionWrapper = (props: IProps) => {
    const {children, "data-testid": dataTestId} = props;

    return (
        <div className={wrapper} data-testid={dataTestId}>
            {children}
        </div>
    );
};

const wrapper = css({
    borderRadius: 2,
    backgroundColor: "var(--colors-white)",
    padding: 3
});
import {ReactNode} from "react";
import {css} from "@panda/css";

interface IProps {
    children: ReactNode;
    "data-testid"?: string;
}

export const DetailSectionWrapper = (props: IProps) => {
    const {children, "data-testid": dataTestId} = props;

    return (
        <div className={wrapper} data-testid={dataTestId}>
            {children}
        </div>
    );
};

const wrapper = css({
    borderRadius: 2,
    backgroundColor: "var(--colors-white)",
    padding: 3
});
